<template>
  <div
    class="clue-remark-module"
    :class="{ isEnglish: $isEnglish }"
  >
    <template v-if="!isEidt">
      <template v-if="data.remarks">
        <div class="clue-remarks-box">
          {{ data.remarks }}
        </div>
        <div
          v-if="isFollowRight"
          class="eidt-clue-remark-btn"
        >
          <a
            href="javascript:;"
            class=""
            @click="handleRemarkEdit"
          >修改</a>
        </div>
      </template>
      <div
        v-else
        class="empty-box"
      >
        <i class="iconfont iconicon-test38 logo" /><p
          class="placeholder"
        >
          暂无线索备注内容
        </p>
        <a-button
          v-if="isFollowRight"
          type="primary"
          style="margin-left:15px;"
          @click="handleRemarkEdit"
        >
          添加备注
        </a-button>
      </div>
    </template>
    <a-form
      v-else
      :form="form"
    >
      <a-form-item
        class="add-box clearfix"
      >
        <div class="textarea clearfix">
          <a-textarea
            v-decorator="['remarks', {
              rules: [{ required: true, message: '请输入线索备注'}],
              initialValue: data.remarks || ''
            }]"
            placeholder="请输入线索备注"
          />
        </div>
      </a-form-item>
      <a-form-item class="clearfix">
        <a-button
          type="primary"
          :loading="confirmLoading"
          @click="handleSumbit"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button
          @click="handleReset"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// const FROM_SOPURCE = 'notice'
export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isFollowRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      isEidt: false
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['permissionInfo', 'formData']),
    clueId () {
      return this.$route.params.id || ''
    }
  },
  async created () {
  },

  destroyed () {
    // eventBus.$off('eidtClueRemarks')
  },

  methods: {
    ...mapActions('inquery/detailData', [
      'eidtClueRemarks'
    ]),
    handleSumbit () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return
          const params = {
            clueid: this.clueId,
            ...values
          }
          this.confirmLoading = true
          const chain = await this.eidtClueRemarks(params)
          chain
            .onSuccess((res = {}) => {
              this.data.remarks = values.remarks
              // this.$message.success('线索备注编辑成功！')
              this.handleRemarkEdit()
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleReset () {
      this.handleRemarkEdit()
      this.form.resetFields()
    },
    handleRemarkEdit () {
      this.isEidt = !this.isEidt
    }
  }
}
</script>

<style lang="scss" scoped>
.clue-remark-module::v-deep{
  .clue-remarks-box{
    width: 416px;
    color: #666;
    word-break: break-all;
    line-height: 24px;
  }
  .eidt-clue-remark-btn{
    text-align: right;
    margin-top: 6px;
  }
.ant-form{
  .ant-form-item-control-wrapper{
    padding-left: 0 !important;
  }
  .ant-btn{
    float: right;
    margin-top: -8px;
    &.ant-btn-primary{
      margin-right: 0;
    }

  }
}
}
.add-box {
    textarea.ant-input {
      display: block;
      width: 406px;
      height: 160px;
      color: #666;
    }
    .placeholder {
      margin-left: 16px;
    }
  }
.isEnglish {
  .list-box .name {
    width: 123px;
  }
}
</style>
